export default __webpack_public_path__ + "static/kurorty-img-1-0a5286a37473468f47a142cd01a5da8a.png";